<template>
  <div>
    <generic-container
      :title="product.name"
      icon="box"
      :searchable="false"
      :show_plus="false"
      :configurable="false"
      :header_buttons="header_buttons"
    >
      <a class="ui blue ribbon icon label" v-if="product.internal_reference">
        <i class="asterisk icon"></i>
        {{ $t("internal reference") }}: {{ product.internal_reference }}
      </a>
      <div class="ui grid">
        <div class="twelve wide column">
          <div class="ui items">
            <div class="item">
              <div class="ui small circular image">
                <img src="/images/icons/product-1.png" />
              </div>
              <div class="content">
                <a class="header">{{ product.name }}</a>
                <div class="meta">
                  <span>
                    {{ $t("since") }}
                    {{ product.description }}
                  </span>
                </div>
                <div class="description">
                  <div class="ui divided selection list">
                    <a
                      class="item"
                      v-bind:class="{ hidden: !attribute.value }"
                      v-for="(attribute, index) in product.setup.attributes"
                      v-bind:key="index"
                    >
                      <div class="ui basic green tag label">
                        {{ attribute.name }}
                      </div>
                      <div class="ui basic label">{{ attribute.value }}</div>
                    </a>
                  </div>
                </div>
                <div
                  class="extra"
                  v-if="
                    product.setup &&
                    product.setup.compoundment &&
                    product.setup.compoundment.length
                  "
                >
                  <h4 class="ui dividing header">{{ $t("compoundment") }}</h4>
                  <div class="ui list" style="margin-top: 15px">
                    <div
                      class="item"
                      v-for="(prd, idx) in product.setup.compoundment"
                      :key="idx"
                    >
                      <i class="blue check icon"></i>
                      {{ prd.quantity }} x {{ prd.product.name }}
                    </div>
                  </div>
                </div>
                <div class="extra">
                  <div
                    class="ui left floated compact basic segment"
                    v-if="product.available_for_sale"
                  >
                    <i class="circular green check icon"></i>
                    {{ $t("available for sale") }}
                  </div>
                  <div
                    class="ui left floated compact basic segment"
                    v-if="product.available_for_purchase"
                  >
                    <i class="circular green check icon"></i>
                    {{ $t("available for purchase") }}
                  </div>
                </div>
                <div class="extra">
                  <div
                    class="ui small green statistic"
                    v-if="product.sale_price"
                  >
                    <div class="value">
                      {{
                        product.sale_price
                          | formatCurrency(enterprise_setup.currency_iso)
                      }}
                    </div>
                    <div class="label">{{ $t("sale price") }}</div>
                  </div>
                  <div class="ui small orange statistic" v-if="product.cost">
                    <div class="value">
                      {{
                        product.cost
                          | formatCurrency(enterprise_setup.currency_iso)
                      }}
                    </div>
                    <div class="label">{{ $t("cost") }}</div>
                  </div>
                  <div
                    class="ui tiny olive statistic"
                    v-bind:class="{ hidden: !vr.value }"
                    v-for="(vr, idx) in product.setup.variations"
                    :key="idx"
                  >
                    <div class="value">
                      {{
                        vr.value | formatCurrency(enterprise_setup.currency_iso)
                      }}
                    </div>
                    <div class="label">{{ vr.name }}</div>
                  </div>
                  <!-- <pre>{{ product.setup }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="four wide column">
          <div class="ui basic right floated segment">
            <barcode v-bind:value="product.barcode" v-if="product.barcode">
              {{ $t("error rendering barcode") }}
            </barcode>
          </div>
        </div>
        <!-- <pre>{{ product }} </pre> -->
      </div>
    </generic-container>
    <component
      :is="submodule.setup.plugin.component"
      :module="submodule"
      :product="product"
      v-for="(submodule, index) in submodules"
      v-bind:key="index + '-' + submodule.module_id"
    ></component>
    <template v-for="(mdl, index) in product_modals">
      <component
        :is="mdl"
        :key="index + '-' + product.uuid"
        :product="product"
        v-on:destroy="modal_destroy"
        v-on:succedded="product_modal_succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  load_submodules,
  enterprise_setup,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ProductPicturePlugin from "@/modules/product_picture/ProductPicturePlugin";
import ProductInventoryFlowPlugin from "@/modules/product_inventory_flow/ProductInventoryFlowPlugin";
import ProductCategoryPlugin from "@/modules/product_category/ProductCategoryPlugin";
import ProductModal from "./product_modal/ProductModal";
import VueBarcode from "vue-barcode";

// @ is an alias to /src
export default {
  name: "ProductView",
  components: {
    "generic-container": GenericContainer,
    ProductPicturePlugin,
    ProductInventoryFlowPlugin,
    barcode: VueBarcode,
    ProductCategoryPlugin,
  },
  filters: filters,
  data() {
    return {
      product: { setup: {} },
      configuration: {},
      header_buttons: [
        {
          color: "orange",
          icon: "edit",
          click: this.edit,
        },
        {
          color: "red",
          icon: "trash",
          click: this.remove,
        },
      ],
      product_modals: [],
      submodules: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove product?"),
        function () {
          local_api(vm, "post", "/product/do-remove", { u: vm.product.uuid })
            .then(() => {
              vm.$router.push({
                name: "ProductIndex",
              });
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit() {
      this.product_modals.push(ProductModal);
    },
    modal_destroy() {
      setTimeout(() => {
        this.product_modals = [];
      }, 200);
    },
    product_modal_succedded(product) {
      product.setup = JSON.parse(product.setup);
      this.product = product;
      this.modal_destroy();
    },
  },
  mounted() {
    let vm = this;

    load_submodules(vm, "product");

    local_api(vm, "post", "/product/do-get-configuration")
      .then((configuration) => {
        vm.configuration = configuration;
      })
      .catch((err) => {
        error_toast(err);
      });

    let product_uuid = this.$route.query.i;
    if (product_uuid) {
      local_api(vm, "post", "/product/do-get", { u: product_uuid })
        .then((product) => {
          vm.product = product;
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no product found"));
    }
  },
  watch: {},
};
</script>

<style>
.hidden {
  display: none !important;
}
</style>
